export default __webpack_public_path__ + "static/media/business-and-trade.90d1d60e.svg";